import React from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Flex, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { AudioFeature } from '../../../types/audioFeature';
import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';

import { AudioIconStack } from './AudioIconStack';

export type AudioHeaderProps = {
	featureList: AudioFeature[];
};

const styles = cssMap({
	iconTileContainer: {
		marginBlockEnd: token('space.200'),
	},
	authorIconContainer: {
		borderRadius: token('radius.large'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		height: '16px',
		width: '16px',
		flexShrink: 0,
	},
});

export const AudioHeader = ({ featureList }: AudioHeaderProps): React.JSX.Element => {
	const { activeContent, pendingContent } = useAudioPlayerStore();

	const contentTitle = pendingContent?.title || activeContent.title || 'Untitled';
	const contentByline = activeContent.author || '';

	return (
		<Box>
			<Box xcss={styles.iconTileContainer}>
				<AudioIconStack featureList={featureList} />
			</Box>

			<Stack alignInline="center" space="space.050">
				<Heading size="medium">{contentTitle}</Heading>
				<Inline space="space.075" alignBlock="center">
					<Flex xcss={styles.authorIconContainer} alignItems="center" justifyContent="center">
						{/* Icon placeholder */}
						<Box />
					</Flex>
					<Text color="color.text.subtlest" maxLines={1}>
						{contentByline}
					</Text>
				</Inline>
			</Stack>
		</Box>
	);
};
